import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ObjectPath } from '@bo-client/shared/types/ObjectPath.type';
import { NBPConfig } from '@bo-client/shared/config.model';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tenant-config-proxy',
  templateUrl: './tenant-config-proxy.component.html',
  styleUrl: './tenant-config-proxy.component.scss'
})
export class TenantConfigProxyComponent implements OnInit {
  @Input() configPath!: ObjectPath<NBPConfig>;
  @Input() redirectOnDeactivated: boolean = false;
  @Input() redirectPath: string = '/';

  configActive$: Observable<boolean> = of(null);
  private dataShareService = inject(DataShareService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  ngOnInit(): void {
    this.configActive$ = this.dataShareService.getSingleTenantConfig$<unknown>(this.configPath).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((config) => !!config),
      shareReplay(1)
    );
    /* Der Code soll erst mal nicht benutzt werden, da es Probleme mit der Navigation gibt.
    if (this.redirectOnDeactivated) {
      this.configActive$.subscribe((value) => {
        if (value === false) {
          this.toRedirect();
        }
      });
    }
    */
  }

  toRedirect() {
    this.router.navigate([this.redirectPath]).then();
  }
}
